import { Box, Typography } from "@mui/material";
import React from "react";

const ROW_SX = {
    lineHeight: 1.45,
    fontSize: "0.8125rem",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
};

const LABEL_SX = {
    fontWeight: 700,
    color: "rgba(30, 58, 47, 0.78)",
    mr: 0.5,
};

function formatClueItems(items) {
    return items
        .map(({ word, hint }) => (hint ? `${word} — ${hint}` : word))
        .join(" · ");
}

function ClueDirectionRow({ label, items }) {
    if (!items?.length) return null;
    return (
        <Typography variant="body2" color="text.secondary" sx={ROW_SX}>
            <Box component="span" sx={LABEL_SX}>
                {label}
            </Box>
            {formatClueItems(items)}
        </Typography>
    );
}

export default function CrosswordClueTeaserDescription({ teaser, acrossLabel, downLabel }) {
    if (!teaser) return null;

    return (
        <Box sx={{ mt: 0.75, display: "flex", flexDirection: "column", gap: 0.35 }}>
            <ClueDirectionRow label={acrossLabel} items={teaser.across} />
            <ClueDirectionRow label={downLabel} items={teaser.down} />
        </Box>
    );
}
